export const ICON_SET = {
  adaptability: "adaptability",
  search: "search",
  clear: "clear",
  edit: "edit",
  delete: "delete",
  send: "send",
  view: "view",
  chevronLeft: "chevron-left",
  chevronRight: "chevron-right",
  question: "question",
  mail: "mail",
  notification: "notification",
  close: "close",
  assign: "assign",
  save: "save",
  add: "add",
  dropdown: "dropdown",
  userIcon: "user-icon",
  layers: "layers",
  aiIcon: "ai-icon",
  upload: "upload",
  database: "database",
  file: "file",
  check: "check",
  checkBoxUnselected: "check-box-unselected",
  checkBoxPreselected: "check-box-preselected",
  checkBoxPostselected: "check-box-postselected",
  chart: "chart",
  dashboard: "dashboard",
  pencil: "pencil",
  lock: "lock",
  bulletList: "bullet-list",
  checkMark: "check-mark",
  gear: "gear",
  arrowUp: "arrow-up",
  arrowDown: "arrow-down",
  lightning: "lightning",
  pieChart: "pie-chart",
  editIcon2: "editIcon2",
  columns: "columns",
  copy: "copy",
  group: "group",
  pulseText: "pulse-text",
  pulseScale: "pulse-scale",
  pulseMulti: "pulse-multi",
  pulseSingle: "pulse-single",
  refresh: "refresh",
};
